import React from 'react';
import {Outlet} from "react-router-dom";
import {AuthService} from "../../service/AuthService";
import {Forbidden} from "../../components/Forbidden";

export const Partner = () => {
  return (
    <>
      { !AuthService.hasRole('ROLE_PARTENAIRE') && (
        <Forbidden module="partner"/>
      )}
      { AuthService.hasRole('ROLE_PARTENAIRE') && (
        <Outlet/>
      )}
    </>
  );
}
